import { ComponentProps } from "react";
import { Checkbox } from "antd";

type CheckboxProps = ComponentProps<typeof Checkbox>;

const CheckboxDefault = ({ value, ...rest }: CheckboxProps) => {
  return <Checkbox checked={value} {...rest} className="form__checkbox" />;
};

export default CheckboxDefault;
